import { Grid } from "@mantine/core";
import { useColors } from "../../../hooks/colors/useColors";
import { BlogData, useBlogList } from "../../../hooks/react-query/useBlogList";

import { useTranslation } from "next-i18next";
import { MyH1 } from "../../UI/my-h1/MyH1";
import {BlogCol} from "../homepage/blog/blog-col";

export function MoreEntries(props: { entry: BlogData }) {
  const { blogs, getFirstNArticles } = useBlogList();
  const { colors } = useColors();
  const { t } = useTranslation("common");

  return (
      <Grid>
        <Grid.Col span={12}>
          <MyH1 color={colors.primary} className="text-center mt-6">
            {t("more-articles")}
          </MyH1>
        </Grid.Col>
        <>
          {blogs &&
              Object.keys(getFirstNArticles(blogs, 3, props.entry)).map(
                  (key, index) => {
                    const blogPost = blogs[key];
                    return <BlogCol key={index} id={key} data={blogPost} />;
                  }
              )}
        </>
      </Grid>
  );
}

// import { Grid } from "@mantine/core";
// import { useColors } from "../../../hooks/colors/useColors";
// import { useTranslation } from "next-i18next";
// import { filterBlogsByCategory } from "../../../services/fetch-data/blogUtil";
// import { useState } from "react";
// import useAsyncEffect from "use-async-effect";
// import { useRouter } from "next/router";
// import { Post } from "../../../types/graphql";
// import { BlogCard } from "../homepage/blog/BlogCard";
//
// export function MoreEntries({ post }: { post: Post }) {
//   const { colors } = useColors();
//   const { t } = useTranslation("common");
//   const router = useRouter();
//
//   const [blogs, setBlogs] = useState<Post[]>();
//   useAsyncEffect(async () => {
//     if (post.categories && post.categories.nodes.length > 0 && router.locale) {
//       const blogs = await filterBlogsByCategory(
//         router.locale,
//         post.categories.nodes.filter(
//           (category) => category.slug && !category.slug.includes("blog-")
//         )[0].slug!,
//         3
//       );
//
//       setBlogs(
//         // @ts-ignore
//         blogs.data.categories.edges[0].node!.posts!.nodes.filter(
//           (entry) => entry.id !== post.id
//         )
//       );
//     }
//   }, [post, router.locale]);
//
//   return (
//     <Grid>
//       <Grid.Col span={12}>
//         <h2
//           style={{ color: colors.primary }}
//           className="text-center mt-6 text-4xl"
//         >
//           {t("more-articles")}
//         </h2>
//       </Grid.Col>
//       <>
//         {blogs &&
//           blogs.map((post, index) => {
//             return <BlogCard key={index} data={post} />;
//           })}
//       </>
//     </Grid>
//   );
// }
